<template>
  <div class="header">
    <div class="logo_container">
      <a href="/" :class="{ disabled: props.displayOnly }" @click="handleClick">
        <img id="bge-logo" src="../assets/images/logo.png" alt="logo portail" />
        <img id="bge-adil-logo" src="../assets/images/info_adil.svg" alt="logo portail" style="height: 20px;" />
      </a>
      <template v-if="userStore.isLoggedIn">
        <p @click="toggle_user_info">Bonjour {{ userStore.current_user?.first_name }}</p>
        <template v-if="userStore.current_user_groups.includes('SWITCH_USER') ||userStore.isImpersonating">
          <select v-if="users_list.length" v-model="selected_user_id" @change="switch_user">
            <option v-for="user in users_list" :key="user.id" :value="user.id">
              {{ user.last_name }} {{ user.first_name }}
            </option>
          </select>
          <div v-if="userStore.isImpersonating" class="debug">
            MODE SWITCH
          </div>
          <div class="debug" @click="toggleDebugMode" v-if="userStore.isImpersonating ||userStore.current_user_groups.includes('SWITCH_USER')">
            <template v-if='userStore.debug_mode'>
              MODE DEBUG
            </template>
            <template v-else>
              MODE REEL
            </template>
          </div>
        </template>
      </template>
    </div>

    

    <div class="login_container" v-if="!props.displayOnly">
      <template v-if="userStore.isLoggedIn">
        <router-link
          to="/gerer_utilisateurs"
          v-if="userStore.current_user_groups.includes('ADMIN_PANEL')"
        >
          <p class="primary-button-discret"><i class="material-icons">manage_accounts</i>&nbsp;Gérer Utilisateurs</p>
        </router-link>
        <a href="/Messagerie_home" class="primary-button-discret">
          <i class="material-icons">send</i>&nbsp; Messagerie &nbsp;
          <span :class="{ badge: nb_messages > 0, 'badge-neutral': nb_messages === 0 }">
            {{ nb_messages }}
          </span>
        </a>
        <button @click="logout" class="primary-button-discret">
          <i class="material-icons">logout</i>&nbsp; Se Déconnecter
        </button>
      </template>
      <template v-else>
        <button @click="toggle_signup" class="primary-button-outlined">S'inscrire</button>
        <button @click="toggle_login" class="primary-button">Se connecter</button>
      </template>
    </div>
  </div>

  <Modal v-model="showLogin">
    <Login v-if="etapeLogin === 'login'" @forgot="etapeLogin = 'forgot'" @closeModal="showLogin = false" />
    <MdpOublie v-if="etapeLogin === 'forgot'" @closeModal="showLogin = false"></MdpOublie>
  </Modal>

  <Modal v-model="showSignUP">
    <Register/>
  </Modal>

  <Modal v-model="showUserInfo">
    <UserInfo @closeMe="showUserInfo = false" />
  </Modal>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import Modal from './Modal.vue'
import Login from './Login.vue'
import Register from './Register.vue'
import MdpOublie from './MdpOublie.vue'
import UserInfo from './UserInfo.vue'
import { useUserStore } from '@/stores/userstore'
import apiClient, { setAuthToken } from '@/api'
import { useRouter } from 'vue-router'

const userStore = useUserStore()
const router = useRouter()

const props = defineProps({
  displayOnly: { type: Boolean, default: false }
})

const etapeLogin = ref('login')

const showUserInfo = ref(false)
const toggle_user_info = () => (showUserInfo.value = !showUserInfo.value)

const showLogin = ref(false)
const showSignUP = ref(false)
const toggle_login = () => {
  showLogin.value = !showLogin.value
  etapeLogin.value = 'login'
}

const toggle_signup= () => {
  showSignUP.value = !showSignUP.value
  // etapeLogin.value = 'signup'
}

const logout = async () => {
  try {
    // Optionally send refresh token to invalidate in backend later
    await apiClient.post('/logout/', {}, { withCredentials: true })
  } catch (err) {
    console.warn('Backend logout failed, removing local state anyway')
  }

  // Clear local tokens
  userStore.removeToken()
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')

  // Redirect
  router.push('/')
}


const users_list = ref([])
const selected_user_id = ref(null)

const fetchUsersList = async () => {
  try {
    if (userStore.isLoggedIn) {
      const response = await apiClient.get('users_list/', { params : {hide_archived: true} })
      users_list.value = response.data.sort((a, b) => a.last_name.localeCompare(b.last_name))

      
      
    } else {
      users_list.value = []
    }
  } catch (error) {
    console.error("Erreur fetchUsersList:", error)
  }
}

const switch_user = async () => {
  const id_user = selected_user_id.value
  if (!id_user) return

  console.log("🔁 Switching to user ID:", id_user)

  try {
    // Récupère le token du nouvel utilisateur
    const response = await apiClient.post("user_token/", { user_id: id_user })
    const { access, refresh } = response.data

    // Important : Applique le token tout de suite dans Axios AVANT d'appeler userStore.setToken
    setAuthToken(access)
    localStorage.setItem("accessToken", access)
    localStorage.setItem("refreshToken", refresh)

    // Ensuite, mets à jour le store (ce qui déclenche la récupération des infos utilisateur)
    await userStore.setToken(access, refresh)

  } catch (err) {
    console.error("User switch failed", err)
  }
}


// 🔁 mise à jour messages à chaque changement d'user
const nb_messages = ref(0)
const get_nb_messages = async () => {
  try {
    const response = await apiClient.get('GetMessageCounts/')
    nb_messages.value = response.data.untreated_count
  } catch (err) {
    console.error("Erreur récupération des messages", err)
  }
}

watch(() => userStore.isLoggedIn, async () => {
  await fetchUsersList()
})

watch(() => userStore.current_user, async () => {
  await get_nb_messages()
})

const toggleDebugMode = ()=>{
  userStore.debug_mode = !userStore.debug_mode
}

const isTokenValid = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1] || ''))
    if (!payload.exp) return false
    return payload.exp * 1000 > Date.now()
  } catch (error) {
    console.error('❌ Unable to parse token payload:', error)
    return false
  }
}

function handleClick(event) {
  if (props.displayOnly) {
    event.preventDefault()
  }
}

onMounted(async () => {
  const token = localStorage.getItem('accessToken')
  if (token && isTokenValid(token)) {
    await userStore.setToken(token)
  } 
  else if (token) {
    userStore.removeToken()
  }
  
  if(userStore.isLoggedIn){
    await fetchUsersList()
    await get_nb_messages()
  }
  selected_user_id.value = userStore.current_user?.id || null
})
</script>

<style scoped lang="scss">

.header {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: center;
  align-items: center;
  background-color: white;
  height: auto;
  min-height: 3.75rem;

  img {
    height: 35px;
  }

  &:has(.disabled) {
      display: flex;
  }

  .disabled {
    cursor: default;
  }
}

.logo_container,
.logo_container a {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  padding-left: 1rem;

  a,
  a:visited {
    text-decoration: none;
  }
}

.login_container {
  display: inline-flex;
  justify-content: end;
  gap: 2rem;
  padding: 0.5rem;

  button {
    padding: 0.7rem;
    margin: 0;
  }
}

.badge {
  background-color: $red;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: bold;
  animation: blink-animation 1s steps(2, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}

.badge-neutral {
  border: 1px solid $base-blue;
  color: $base-blue;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

.debug{
  font-size:x-small;
  padding: 0.2rem;
  background-color: $light-orange;
  border-radius: 5px;
  cursor: pointer;
  user-select: none;
}
</style>
